import {eatalianoAxios} from "@/data/api/http/axios";
import {EmployeeDetails, EmployeeFormValues, EmployeeStatus} from "@/data/entities/employee";
import { Message } from "@/data/entities/message";

export const getEmployeeStatus = (employeeCode: string): Promise<EmployeeStatus> => (
    eatalianoAxios
        .get(`/employees/${employeeCode}/status`)
        .then(response => response.data)
);

export const deleteEmployee = (employeeId: number): Promise<Message> => (
    eatalianoAxios
        .delete(`/employees/${employeeId}`)
        .then(response => response.data)
);

export const clockIn = (employeeCode: string): Promise<EmployeeStatus> => (
    eatalianoAxios
        .put(`/employees/time-entries/${employeeCode}/start`)
        .then(response => response.data)
);

export const clockOut = (employeeCode: string): Promise<EmployeeStatus> => (
    eatalianoAxios
        .put(`/employees/time-entries/${employeeCode}/stop`)
        .then(response => response.data)
);

export const getEmployeeDetails = (employeeId: number): Promise<EmployeeDetails> => (
    eatalianoAxios
        .get(`/employees/${employeeId}`)
        .then(response => response.data)
);

export const createEmployee = (
    restaurantId: number,
    fields: Omit<EmployeeFormValues, "code">,
): Promise<EmployeeDetails> => (
    eatalianoAxios
        .post(`/employees/${restaurantId}/new`, fields)
        .then(response => response.data)
);

export const updateEmployee = (
    employeeId: number,
    fields: EmployeeFormValues,
): Promise<EmployeeDetails> => (
    eatalianoAxios
        .put(`/employees/${employeeId}`, fields)
        .then(response => response.data)
);
